import React, { useState, useEffect, } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Avatar,
    Typography,
    Stack,
    Button,
    Tooltip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Snackbar,
    Alert,
    IconButton,
    Drawer,
    useTheme,
    useMediaQuery,
    AppBar,
    Toolbar,
} from "@mui/material";
import {
    Home,
    Business,
    Assignment,
    Group,
    BarChart,
    History,
    Settings,
    Help,
    TaskSharp,
    LogoutRounded,
    ExitToApp,
    Timer,
    Menu as MenuIcon,
    Close as CloseIcon, AutoStories
} from "@mui/icons-material";
import hrmsDashboardImage from '../../../assets/Hmrs_Hashstack.png'
import ProjectDetails from "../Projects/ProjectDetails";
import axios from "axios";
import TasksPage from "../../Manager/Tasks/newtask";
import { motion, AnimatePresence } from "framer-motion";
import { Header } from "./header";
import { AllCards } from "./AllCards";
import BackIcon from '../../../assets/Back.png';
import { EpicsComponentParent } from "../Epics/EpicComponentParent";
import { ProjectList } from "../Projects/Pro";
import Back from '../../../assets/Back.png';
import AttendancePage from "../Attendance/ManagerAttendance";
import EmployeeLeaves from "../LeaveManagement/LeaveManagement";
import { localAxiosGet } from "../../../Axios/axios";
import TaskDetails from '../../../components/TaskDetails';
import { Assessment as AssessmentIcon } from "@mui/icons-material";
import ManagerPerformanceReviewDashboard from '../../Manager/Performance/ManagerPerformanceReviewDashboard';
import UserStoriesDashboard from '../UserStories/userStoriesDashboard';


export const Manager = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);
    const [currentView, setCurrentView] = useState('projectList');
    const navigate = useNavigate();
    const [selectedMenu, setSelectedMenu] = useState("Home");
    const [isOpen, setIsOpen] = useState(false);
    const [openPunchInDialog, setOpenPunchInDialog] = useState(true);
    const [isPunchedIn, setIsPunchedIn] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [punchInTime, setPunchInTime] = useState(null);
    const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
    const [clickEmployee, setClickEmployee] = useState(false);
    const [clickHr, setClickHr] = useState(false);

    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [viewingTaskDetails, setViewingTaskDetails] = useState(false);
    const [selectedProjectIdForTasks, setSelectedProjectIdForTasks] = useState(null);
    const [taskDeleted, setTaskDeleted] = useState(false);


    // Task filter states
    const [taskFilters, setTaskFilters] = useState({
        searchTerm: '',
        selectedStatusFilter: 'all',
        selectedAssignee: '',
        selectedProject: '',
        selectedCategory: 'all',
        submittedForReview: 'all',
        currentPage: 1,
        rowsPerPage: 10
    });


    const [statusCounts, setStatusCounts] = useState({
        total_task_count: 0,
        'Open': 0,
        'In Progress': 0,
        // 'Submit For Review': 0,
        'Completed': 0,
        'Re Open': 0,
        'Hold': 0,
        'Overdue': 0
    });

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleTaskSelect = (taskId) => {
        setSelectedTaskId(taskId);
        setViewingTaskDetails(true);
        if (isMobile) {
            setMobileOpen(false);
        }
    };

    const handleBackFromTaskDetails = (wasDeleted = false) => {
        setViewingTaskDetails(false);
        setSelectedTaskId(null);

        if (wasDeleted) {
            setShowSuccessSnackbar(true);
        }
    };



    const handleTaskDeleted = () => {
        handleBackFromTaskDetails(true);
    };


    const handleMenuSelect = (menuName) => {
        setViewingTaskDetails(false);
        setSelectedTaskId(null);
        if (menuName !== selectedMenu) {
            resetAllFilters();
        }

        setSelectedMenu(menuName);
        if (isMobile) {
            setMobileOpen(false);
        }
    };


    const handleLogout = () => {
        localStorage.removeItem('lastPunchIn');
        localStorage.removeItem('userToken');
        setOpenLogoutDialog(false);
        setIsPunchedIn(false);
        navigate('/login');
    };

    const menuItems = [
        { name: "Home", icon: <Home /> },
        { name: "Projects", icon: <Business /> },
        { name: "Epics", icon: <Assignment /> },
        // { name: "User Stories", icon: <AutoStories /> }, 
        // { name: "Tasks", icon: <Assignment /> },
        { name: "Attendance Management", icon: <TaskSharp /> },
        { name: "Leave Management", icon: <Group /> },
        { name: "Performance Management", icon: <Assignment /> },
    ];


    const handleBackToHome = () => {
        // Reset filters when explicitly going back to home
        resetAllFilters();
        handleMenuSelect("Home");
    };


    const handleViewTasks = (projectId) => {
        // Reset filters when switching to tasks from projects
        resetAllFilters();
        setSelectedProjectIdForTasks(projectId);
        setSelectedMenu("Tasks");
    };

    const resetAllFilters = () => {
        setTaskFilters({
            searchTerm: '',
            selectedStatusFilter: 'all',
            selectedAssignee: '',
            selectedProject: '',
            selectedCategory: 'all',
            submittedForReview: 'all',
            currentPage: 1,
            rowsPerPage: 10
        });
        setStatusCounts({
            total_task_count: 0,
            'Open': 0,
            'In Progress': 0,
            'Completed': 0,
            'Re Open': 0,
            'Hold': 0,
            'Overdue': 0
        });
        setSelectedProjectIdForTasks(null);
    };

    // Sidebar Content Component
    const SidebarContent = () => (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Mobile Close Button */}
            {isMobile && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
                    <IconButton onClick={handleDrawerToggle} sx={{ color: '#ECF0F1' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            )}

            {/* Logo Image */}
            {!isMobile && (
                <Box sx={{ textAlign: "center", mb: 3, mt: 3, px: 2 }}>
                    <img
                        src={hrmsDashboardImage}
                        alt="HRMS Dashboard"
                        style={{
                            width: "60%",
                            height: "auto",
                            maxWidth: "120px",
                            margin: "0 auto",
                        }}
                    />
                </Box>
            )}

            {/* Menu Items */}
            <Box sx={{ flex: 1, px: 2, mt: { xs: '70px', md: 0 } }}>
                <Stack spacing={1.5} >
                    {menuItems.map((item) => (
                        <Button
                            key={item.name}
                            onClick={() => handleMenuSelect(item.name)}
                            sx={{
                                justifyContent: "flex-start",
                                color: selectedMenu === item.name ? "#FFFFFF" : "#BDC3C7",
                                backgroundColor: selectedMenu === item.name ? "#2980B9" : "transparent",
                                padding: "10px 15px",
                                borderRadius: 1,
                                textTransform: "none",
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                                width: "100%",
                                "&:hover": {
                                    backgroundColor: selectedMenu === item.name
                                        ? "#2980B9"
                                        : "rgba(41, 128, 185, 0.1)",
                                },
                            }}
                        >
                            <Box sx={{ minWidth: "24px" }}>
                                {React.cloneElement(item.icon, {
                                    sx: { fontSize: "20px" }
                                })}
                            </Box>
                            <Typography
                                sx={{
                                    fontSize: "0.875rem",
                                    whiteSpace: { lg: 'normal', xl: 'nowrap' },
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: 'start'
                                }}
                            >
                                {item.name}
                            </Typography>
                        </Button>
                    ))}
                </Stack>
            </Box>
        </Box>
    );

    // Mobile Header Component
    const MobileHeader = () => (
        <AppBar
            position="fixed"
            sx={{
                width: '100%',
                backgroundColor: "transparent",
                display: { isMobile: 'block' },
                zIndex: theme.zIndex.drawer + 1,
                boxShadow: 'none',
            }}
        >
            <Header
                showMobileMenu={true}
                onMenuToggle={handleDrawerToggle}
            />
        </AppBar>
    );

    const renderContent = () => {
        if (viewingTaskDetails && selectedTaskId) {
            return (
                <Box sx={{ display: 'flex', alignItems: 'start' }}>
                    <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                        <img
                            onClick={() => handleBackFromTaskDetails(false)}
                            src={Back}
                            alt="back"
                            style={{
                                width: "30px",
                                height: "30px",
                                cursor: "pointer",
                                marginRight: "10px"
                            }}
                        />
                    </Box>
                    <TaskDetails onClose={() => handleBackFromTaskDetails(false)} taskId={selectedTaskId} onTaskDeleted={handleTaskDeleted} />
                </Box>
            );
        }
        switch (selectedMenu) {
            case "Home":
                return (
                    <Box sx={{ position: 'relative', width: '100%' }}>
                        <Box sx={{ top: 20, float: 'right', marginLeft: 'auto', zIndex: 1 }}>
                            {/* <SmartAttendanceSystem /> */}
                        </Box>
                        <AllCards setSelectedMenu={handleMenuSelect} />
                        {/* <DashboardOverview /> */}
                    </Box>
                );
            case "Projects":
                return currentView === 'projectList' ? (
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                onClick={handleBackToHome}
                                src={Back}
                                alt="back"
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    cursor: "pointer",
                                    marginRight: "10px"
                                }}
                            />
                        </Box>
                        <ProjectList
                            onProjectSelect={(project) => {
                                setSelectedProject(project);
                                setCurrentView('projectDetails');
                            }}
                            onViewTasks={handleViewTasks}
                        />
                    </Box>
                ) : (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                onClick={() => {
                                    setCurrentView('projectList');
                                    setSelectedProject(null);
                                }}
                                src={Back}
                                alt="back"
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    cursor: "pointer",
                                    marginRight: "10px"
                                }}
                            />
                        </Box>
                        <ProjectDetails
                            project={selectedProject}
                            onBackToList={() => {
                                setCurrentView('projectList');
                                setSelectedProject(null);
                            }}
                        />
                    </Box>
                );
            // Replace the entire "Epics" case in Manager.js with this:
            case "Epics":
                return (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                onClick={handleBackToHome}
                                src={BackIcon}
                                alt="back"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateX(-5px)'
                                    }
                                }}
                            />
                        </Box>
                        <EpicsComponentParent />
                    </Box>
                );
            case "User Stories":
                return (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                src={BackIcon}
                                alt="Back"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateX(-5px)'
                                    }
                                }}
                                onClick={handleBackToHome}
                            />
                        </Box>
                        <UserStoriesDashboard />
                    </Box>
                );
            case "Tasks":
                return (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                onClick={handleBackToHome}
                                src={BackIcon}
                                alt="back"
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    cursor: "pointer",
                                    marginRight: "10px"
                                }}
                            />
                        </Box>
                        <TasksPage
                            onTaskSelect={handleTaskSelect}
                            projectId={selectedProjectIdForTasks}
                            taskFilters={taskFilters}
                            setTaskFilters={setTaskFilters}
                            statusCardCounts={statusCounts}
                            setStatusCardCounts={setStatusCounts}
                        />
                    </Box>
                );
            case "Attendance Management":
                return (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                src={BackIcon}
                                alt="Back"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateX(-5px)'
                                    }
                                }}
                                onClick={handleBackToHome}
                            />
                        </Box>
                        <AttendancePage />
                    </Box>
                );
            case "Leave Management":
                return (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                src={BackIcon}
                                alt="Back"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateX(-5px)'
                                    }
                                }}
                                onClick={handleBackToHome}
                            />
                        </Box>
                        <EmployeeLeaves />
                    </Box>
                );
            case "Performance Management":
                return (
                    <Box>
                        <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
                            <img
                                src={BackIcon}
                                alt="Back"
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateX(-5px)'
                                    }
                                }}
                                onClick={handleBackToHome}
                            />
                        </Box>
                        <ManagerPerformanceReviewDashboard />
                    </Box>
                );
            default:
                return null;
        }
    };

    const drawerWidth = 220;

    return (
        <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#f4f4f4" }}>
            {/* Mobile Header */}
            {isMobile && <MobileHeader />}

            {/* Desktop Sidebar */}
            {!isMobile && (
                <Box
                    sx={{
                        width: { xs: drawerWidth, xl: '18%' },
                        flexShrink: 0,
                        backgroundColor: "#2C3E50",
                        color: "#ECF0F1",
                    }}
                >
                    <SidebarContent />
                </Box>
            )}

            {/* Mobile Drawer */}
            <Drawer
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: isMobile ? 'block' : 'none',
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: drawerWidth,
                        backgroundColor: "#2C3E50",
                        color: "#ECF0F1",
                    },
                }}
            >
                <SidebarContent />
            </Drawer>

            {/* Main Content */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    width: { xs: '100%', md: `calc(100% - ${drawerWidth}px)` },
                    ml: { xs: 0, md: 0 },

                }}
            >
                {/* Desktop Header */}
                {!isMobile && <Header />}

                <Box
                    sx={{
                        flexGrow: 1,
                        padding: { xs: "20px", sm: "15px", md: "20px" },
                        background: "#fff",
                        overflowY: "auto",
                        height: { xs: 'calc(100vh - 64px)', md: 'calc(100vh - 64px)' },
                        mt: { xs: '80px', md: '0' }
                    }}
                >
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={selectedMenu}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.3 }}
                        >
                            {renderContent()}
                        </motion.div>
                    </AnimatePresence>
                </Box>

                <Snackbar
                    open={showSuccessSnackbar}
                    autoHideDuration={3000}
                    onClose={() => setShowSuccessSnackbar(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert
                        onClose={() => setShowSuccessSnackbar(false)}
                        severity="success"
                        sx={{ width: '100%' }}
                    >
                        Task deleted successfully!
                    </Alert>
                </Snackbar>
            </Box>
        </Box>
    );
};

export default Manager;